export const OKTA_CONFIG_ISSUER_PROD = 'https://authorize.coxautoinc.com/oauth2/aus132sv79JpAYinE357';
export const OKTA_CONFIG_ISSUER_NON_PROD = 'https://authorize.coxautoinc.com/oauth2/aus132uaxy2eomhmi357';
export const OKTA_OAUTH_CALLBACK = '/oauth-callback';
export const AUTH_SCOPE_BRIDGE_SIGN_IN = 'bridge.signin';
export const AUTH_SCOPE_OPEN_ID = 'openid';
export const AUTH_SCOPE_CXM_BFF_INSIGHTS_READ = 'cxm-private.cxm-ui-bff.insights.read';

// Theme constants
export const DEFAULT_THEME = 'default';

export const DEALER_SUPPORT_REQUEST_FORM = 'https://www.dealer.com/support/requestform/';
